

export default {
    recordState: (state, getters, rootState, rootGetters) => {
        return state.recordState;
    },
    recordingTime: (state, getters, rootState, rootGetters) => {
        return state.recordingTime;
    },
    recordError: (state, getters, rootState, rootGetters) => {
        return state.recordError;
    },
    recordErrorMessage: (state, getters, rootState) => {
        return state.recordErrorMessage;
    },
    recordRemainData: (state, getters, rootState) => {
        return state.recordRemainData;
    },
    recordFileList: (state, getters, rootState) => {
        return state.recordFileList.filter(el => {
            return !!el.endDate;
        });   
    },
}
